module.exports = __webpack_public_path__ + "img/checking_on_dark.6807473e.svg";